
import {throwError as observableThrowError, Observable ,  BehaviorSubject } from 'rxjs';

import {map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { IUser } from '../models/user'
import { ILogin } from '../models/login'
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { SocialLoginInputModel } from '../models/SocialLoginInputModel'
import { SocialLoginOutputModel } from '../models/SocialLoginOutputModel'
import { SharedService } from '../../shared/providers/shared.service';
import { TokenService } from '../../shared/providers/token.service';
import { UserRole } from '../../shared/enum/enum';
import { ToastService } from '../../shared/providers/toast.service';
import { BrowserService } from '../../shared/browser-service.service';
import { PermissionService } from '../providers/permission.service';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  readonly BaseUrl = environment.base_url;
  _user: Observable<IUser>;
  loggedIn = new BehaviorSubject<boolean>(false);
  verifiedIn = new BehaviorSubject<boolean>(false);
  private userDetailsUpdated = new BehaviorSubject<boolean>(false);
  loggedInUserDetails = this.userDetailsUpdated.asObservable();
  redirectUrl = ''; // For 1031 access
  authResponse = {} as IUser;
  socialLoginResponse = {} as SocialLoginOutputModel;
  isAuthenticated = false;
  isAuth0Enabled = true;
  IsCalledTheOtp = false;
  onRegisterRedirection = '';
  redirectUser = new BehaviorSubject<string>('');
  redirect = this.redirectUser.asObservable();
  logoutClicked: boolean = false;
  IsTcModalCalled = false;
  redirectUserTo(value: string) {
    this.redirectUser.next(value);
  }

  reloadUserDetails(value: boolean) {
    this.userDetailsUpdated.next(value);
  }

  constructor(private _http: HttpClient, private router: Router, private Shared: SharedService, private tokenService: TokenService,
    private _toastService: ToastService, private browserService: BrowserService, private permissionService: PermissionService) {
  }

  private handleError(err: HttpErrorResponse) {
    console.log('http error occurred');
    console.log(err.message);
    return observableThrowError(err.message);
  };

  get isLoggedIn() {
    return this.loggedIn.asObservable();
  }

  get isAuthenticatedACcount() {
    return this.verifiedIn.asObservable();
  }

  isUserLoggedIn() {
    return !((this._user === null) || (this._user === undefined));
  }
  get user(): Observable<IUser> {
    if (!this.browserService.document) {
      return;
    }
    else if (this._user === undefined) {
      this._user = JSON.parse(localStorage.getItem('currentUser'));
    }
    return this._user;
  }

  updateUserDetails(user: any) {
    if (this.user !== undefined) {
      this._user = user
    }
  }

  UserRole = UserRole;
  IsUserRole(role: UserRole) {
    try {
      let _user: IUser;
      if (!this.browserService.document) {
        return;
      }
      else if (_user === undefined) {
        _user = JSON.parse(localStorage.getItem('currentUser'));
      }
      if (_user) {
        if (role == UserRole.Principal) {
          return ((_user.RoleIdList.indexOf(UserRole.Principal) > -1) && (_user.RoleIdList.indexOf(UserRole.Principal1031) < 0)) ? true : false;
        }
        else {
          return (_user.RoleIdList.indexOf(role) > -1) ? true : false;
        }
      }
      else {
        return false;
      }
    }
    catch (ex) {
      this.logOutUserOnError(ex);
    }
  }
  Admin() {
    try {
      let _user: IUser;
      if (!this.browserService.document) {
        return;
      }
      else if (_user === undefined) {
        _user = JSON.parse(localStorage.getItem('currentUser'));
      }
      if (_user) {
        return ((_user.RoleIdList.indexOf(UserRole.Admin) > -1)) ? true : false;
      }
      else {
        return false;
      }
    }
    catch (ex) {
      this.logOutUserOnError(ex);
    }
  }

 SuperAdmin() {
    try {
      let _user: IUser;
      if (!this.browserService.document) {
        return;
      }
      else if (_user === undefined) {
        _user = JSON.parse(localStorage.getItem('currentUser'));
      }
      if (_user) {
        return ((_user.RoleIdList.indexOf(UserRole.SuperAdmin) > -1)) ? true : false;
      }
      else {
        return false;
      }
    }
    catch (ex) {
      this.logOutUserOnError(ex);
    }
  }

  Principal() {
    try {
      let _user: IUser;
      if (!this.browserService.document) {
        return;
      }
      else if (_user === undefined) {
        _user = JSON.parse(localStorage.getItem('currentUser'));
      }
      if (_user) {
        return ((_user.RoleIdList.indexOf(UserRole.Principal) > -1) && (_user.RoleIdList.indexOf(UserRole.Principal1031) < 0)) ? true : false;
      }
      else {
        return false;
      }
    }
    catch (ex) {
      this.logOutUserOnError(ex);
    }
  }

  Broker() {
    try {
      let _user: IUser;
      if (!this.browserService.document) {
        return;
      }
      else if (_user === undefined) {
        _user = JSON.parse(localStorage.getItem('currentUser'));
      }
      if (_user) {
        return ((_user.RoleIdList.indexOf(UserRole.Broker) > -1)) ? true : false;
      }
      else {
        return false;
      }
    }
    catch (ex) {
      this.logOutUserOnError(ex);
    }
  }
  Principal1031() {
    try {
      let _user: IUser;
      if (_user === undefined) {
        _user = JSON.parse(localStorage.getItem('currentUser'));
      }
      if (_user) {
        return ((_user.RoleIdList.indexOf(UserRole.Principal1031) > -1)) ? true : false;
      }
      else {
        return false;
      }
    }
    catch (ex) {
      this.logOutUserOnError(ex);
    }
  }
  DataEntryStaff() {
    try {
      let _user: IUser;
      if (!this.browserService.document) {
        return;
      }
      else if (_user === undefined) {
        _user = JSON.parse(localStorage.getItem('currentUser'));
      }
      if (_user) {
        return ((_user.RoleIdList.indexOf(UserRole.DataEntryStaff) > -1)) ? true : false;
      }
      else {
        return false;
      }
    }
    catch (ex) {
      this.logOutUserOnError(ex);
    }
  }

  ExternalBroker() {
    try {
      let _user: IUser;
      if (!this.browserService.document) {
        return;
      }
      else if (_user === undefined) {
        _user = JSON.parse(localStorage.getItem('currentUser'));
      }
      if (_user) {
        return ((_user.RoleIdList.indexOf(UserRole.ExternalBroker) > -1)) ? true : false;
      }
      else {
        return false;
      }
    }
    catch (ex) {
      this.logOutUserOnError(ex);
    }
  }

  Seller() {
    try {
      let _user: IUser;
      if (!this.browserService.document) {
        return;
      }
      else if (_user === undefined) {
        _user = JSON.parse(localStorage.getItem('currentUser'));
      }
      if (_user) {
        return ((_user.RoleIdList.indexOf(UserRole.Seller) > -1)) ? true : false;
      }
      else {
        return false;
      }
    }
    catch (ex) {
      this.logOutUserOnError(ex);
    }
  }

  
  login(loginModel: ILogin): Observable<IUser> {
    if (!this.browserService.document) {
      return;
    }
    return this._http.post<IUser>(this.BaseUrl + "/auth/login", loginModel).pipe(
      map(response => {
        this.authResponse = response;
        localStorage.setItem('currentUser', JSON.stringify(response));
        if (response.Success) {
          this.authResponse.IsAuthenticated = true;
          this._user = JSON.parse(localStorage.getItem('currentUser'));
          this.authResponse.RedirectUrl = this.redirectUrl; // For 1031 access
          localStorage.setItem('auth_token', this.authResponse.Token);
          localStorage.setItem('auth_token_expiry', this.tokenService.GetTokenExpiryDate().toString());
          this.removeLocalStorage();
          this.loggedIn.next(true);
          //this.generateToken(this.authResponse.Id, this.authResponse.UserName);
          return this.authResponse;
        }
        else {
          localStorage.removeItem('currentUser');
          this.authResponse.IsAuthenticated = false;
          this._user = null;
          return this.authResponse;
        }
      }));
  }
  //generateToken(userId: number, userName: string) {
  //    return this._http.get(this.BaseUrl + "/token?userId=" + userId + "&userName=" + userName).subscribe(response => {
  //        localStorage.setItem('auth_token', response.toString());
  //    });
  //}
  checkSocialLoginUser(socialLoginInputModel: SocialLoginInputModel): Observable<SocialLoginOutputModel> {
    return this._http.post<SocialLoginOutputModel>(this.BaseUrl + "/auth/socialLogin", socialLoginInputModel).pipe(
      map(response => {
        this.socialLoginResponse = response;
        if (this.socialLoginResponse.LoginModel.Success) {
          localStorage.setItem('currentUser', JSON.stringify(this.socialLoginResponse.LoginModel));
          this.loggedIn.next(true);
          this.socialLoginResponse.LoginModel.IsAuthenticated = true;
          this._user = JSON.parse(localStorage.getItem('currentUser'));
          this.socialLoginResponse.LoginModel.RedirectUrl = this.redirectUrl; // For 1031 access                   
        }
        return this.socialLoginResponse;
      }));
  }
  removeLocalStorage() {
    try {
      if (!this.browserService.document) {
        return;
      }
      else {
        if (localStorage.getItem("DataTables_property_list_view") !== null) {
          localStorage.removeItem('DataTables_property_list_view');
        }
        if (localStorage.getItem("DataTables_my_property_list_view") !== null) {
          localStorage.removeItem('DataTables_my_property_list_view');
        }
        if (localStorage.getItem("DataTables_property_list_view_Fav") !== null) {
          localStorage.removeItem('DataTables_property_list_view_Fav');
        }
        if (localStorage.getItem("DataTables_property_list_view_Disliked") !== null) {
          localStorage.removeItem('DataTables_property_list_view_Disliked');
        }
        if (localStorage.getItem("DataTables_All_Messagelist_view") !== null) {
          localStorage.removeItem('DataTables_All_Messagelist_view');
        }
      }

    }
    catch (ex) {

    }
  }

  // this methode retuns actual role name corresponding to each input role id.
  // output role id should match with the roles in the UserRoles table of the DB
  getUserRoleDescription(role: number) {
    switch (role) {
      case UserRole.Admin: {
        return 'Admin';
      }
      case UserRole.Principal: {
        return 'Principal';
      }
      case UserRole.Broker: {
        return 'B+E Broker';
      }
      case UserRole.Principal1031: {
        return 'Principal+1031';
      }
      case UserRole.InternalUser: {
        return 'Internal User';
      }
      case UserRole.CoBroker: {
        return 'Co-Broker';
      }
      case UserRole.ComplianceBroker: {
        return 'Compliance Broker';
      }
      case UserRole.GuestUser: {
        return 'Guest User';
      }
      case UserRole.ExternalBroker: {
        return 'Broker';
      }
      case UserRole.SuperAdmin: {
        return 'Super Admin';
      }
      default: {
        break;
      }
    }
  }

  logout() {
    // remove user from local storage to log user out
    if (!this.browserService.document) {
      return;
    }
    this.loggedIn.next(false);
    this._user = null;
    this.authResponse = null;
    this.redirectUrl = ""; // For 1031 access
    this.Shared.changeSelectedExchange(0);
    localStorage.removeItem('currentUser');
    this.removeLocalStorage();
    localStorage.clear();
    //this.router.navigate([this.router.url]);

  }

  Auth0login(loginModel: ILogin): Observable<IUser> {
    if (!this.browserService.document) {
      return;
    }
    return this._http.post<IUser>(this.BaseUrl + "/auth/Auth0login", loginModel)
      .pipe(map(response => {
        this.authResponse = response;
        localStorage.setItem('currentUser', JSON.stringify(response));
        if (response.Success) {
          this.loadRoleBasedPermissions(this.authResponse.RoleId);
          this.authResponse.IsAuthenticated = true;
          this._user = JSON.parse(localStorage.getItem('currentUser'));
          this.authResponse.RedirectUrl = this.redirectUrl; // For 1031 access
          //this.generateToken(this.authResponse.Id, this.authResponse.UserName);
          localStorage.setItem('auth_token', this.authResponse.Token);
          localStorage.setItem('auth_token_expiry', this.tokenService.GetTokenExpiryDate().toString());
          this.removeLocalStorage();
          this.loggedIn.next(true);
          return this.authResponse;
        }
        else {
          localStorage.removeItem('currentUser');
          this.authResponse.IsAuthenticated = false;
          this._user = null;
          return this.authResponse;
        }
      }));
  }

  logOutUserOnError(ex) {

    if (!this.browserService.document) {
      return;
    }
    let errosCall = localStorage.getItem("errorCall") == 'undefined' || localStorage.getItem("errorCall") == "NaN" ? 0 : parseInt(localStorage.getItem("errorCall"));
    if (errosCall < 1 && (ex.message == "Cannot read property 'indexOf' of null" ||
      ex.message == "Cannot read property 'indexOf' of undefined" || ex.message == "l.RoleIdList is undefined")) {
      localStorage.setItem('errorCall', (errosCall + 1).toString());
      this._toastService.addToast({
        title: 'Warning',
        msg: 'New updates and features are available,  Please re-login for a seamless experience',
        timeout: 10000,
        theme: 'bootstrap',
        position: 'bottom-right',
        type: 'warning'
      });
    }
    else if (errosCall == 1) {
      if (!this.browserService.document) {
        return;
      }
      localStorage.setItem('errorCall', (errosCall + 1).toString());
      let timeout = setTimeout(function () {
        localStorage.setItem('errorCall', '0');
        clearTimeout(timeout)
      }, 300000);
    }

  }

 loadRoleBasedPermissions(roleId: number) {
   this.permissionService.getAllowedPermissions(roleId).subscribe(response => {
     this.permissionService.setPermissions(response);
   });
 }
}
